/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Oceania_DescriptionInputs */

const bn_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পূর্ণ ওশেনিয়া অঞ্চল, দ্বীপগুলি অন্তর্ভুক্ত।`)
};

const de_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesamte Region Ozeanien, einschließlich der Inseln.`)
};

const el_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η πλήρης περιοχή της Ωκεανίας, συμπεριλαμβανομένων των νησιών.`)
};

const en_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The full Oceania region, islands included.`)
};

const es_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda la región de Oceanía, islas incluidas.`)
};

const fr_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute l’Océanie, îles incluses.`)
};

const hi_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपूर्ण ओशिनिया क्षेत्र, द्वीप शामिल।`)
};

const hu_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A teljes Óceánia régió, beleértve a szigeteket is.`)
};

const id_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seluruh wilayah Oseania, termasuk pulau-pulau.`)
};

const it_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intera regione dell'Oceania, isole comprese.`)
};

const ja_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`島を含むオセアニア全域。`)
};

const ko_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`섬이 포함된 전체 오세아니아 지역.`)
};

const nl_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De volledige regio Oceanië, inclusief de eilanden.`)
};

const pl_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały region Oceanii, łącznie z wyspami.`)
};

const pt_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda a região da Oceania, incluindo ilhas.`)
};

const ru_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь регион Океании, включая острова.`)
};

const sv_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hela Oceanien-regionen, inklusive öar.`)
};

const tr_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okyanusya bölgesinin tamamı, adalar dahil.`)
};

const uk_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повний регіон Океанії, включаючи острови.`)
};

const vi_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ khu vực Châu Đại Dương, bao gồm cả các đảo.`)
};

const zh_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整个大洋洲地区，包括岛屿。`)
};

const zh_hant_intro_region_oceania_description = /** @type {(inputs: Intro_Region_Oceania_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整個大洋洲地區，包括島嶼。`)
};

/**
* | output |
* | --- |
* | "The full Oceania region, islands included." |
*
* @param {Intro_Region_Oceania_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_oceania_description = /** @type {((inputs?: Intro_Region_Oceania_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Oceania_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_oceania_description(inputs)
	if (locale === "de") return de_intro_region_oceania_description(inputs)
	if (locale === "el") return el_intro_region_oceania_description(inputs)
	if (locale === "en") return en_intro_region_oceania_description(inputs)
	if (locale === "es") return es_intro_region_oceania_description(inputs)
	if (locale === "fr") return fr_intro_region_oceania_description(inputs)
	if (locale === "hi") return hi_intro_region_oceania_description(inputs)
	if (locale === "hu") return hu_intro_region_oceania_description(inputs)
	if (locale === "id") return id_intro_region_oceania_description(inputs)
	if (locale === "it") return it_intro_region_oceania_description(inputs)
	if (locale === "ja") return ja_intro_region_oceania_description(inputs)
	if (locale === "ko") return ko_intro_region_oceania_description(inputs)
	if (locale === "nl") return nl_intro_region_oceania_description(inputs)
	if (locale === "pl") return pl_intro_region_oceania_description(inputs)
	if (locale === "pt") return pt_intro_region_oceania_description(inputs)
	if (locale === "ru") return ru_intro_region_oceania_description(inputs)
	if (locale === "sv") return sv_intro_region_oceania_description(inputs)
	if (locale === "tr") return tr_intro_region_oceania_description(inputs)
	if (locale === "uk") return uk_intro_region_oceania_description(inputs)
	if (locale === "vi") return vi_intro_region_oceania_description(inputs)
	if (locale === "zh") return zh_intro_region_oceania_description(inputs)
	return zh_hant_intro_region_oceania_description(inputs)
});